// Gemeinsame Ticket-Definitionen fuer zentralen Bereich + Standort-Detail

export const TICKET_STATUS = [
  { id: "open", de: "Offen", en: "Open", cls: "text-sky-700 bg-sky-50 border-sky-200", dot: "bg-sky-500" },
  { id: "in_progress", de: "In Arbeit", en: "In progress", cls: "text-amber-700 bg-amber-50 border-amber-200", dot: "bg-amber-500" },
  { id: "waiting", de: "Wartet auf Teil/Versand", en: "Waiting for part/shipping", cls: "text-slate-700 bg-slate-100 border-slate-200", dot: "bg-slate-500" },
  { id: "closed", de: "Erledigt", en: "Done", cls: "text-green-700 bg-green-50 border-green-200", dot: "bg-green-500" },
];

export const TICKET_CATEGORY = [
  { id: "ersatzteil", de: "Ersatzteil", en: "Spare part" },
  { id: "kabel", de: "Kabel", en: "Cable" },
  { id: "geraet", de: "Gerät", en: "Device" },
  { id: "konfiguration", de: "Konfiguration", en: "Configuration" },
  { id: "sonstiges", de: "Sonstiges", en: "Other" },
];

export const TICKET_PRIORITY = [
  { id: "high", de: "Hoch", en: "High", cls: "text-red-700 bg-red-50 border-red-200" },
  { id: "normal", de: "Normal", en: "Normal", cls: "text-amber-700 bg-amber-50 border-amber-200" },
  { id: "low", de: "Niedrig", en: "Low", cls: "text-gray-600 bg-gray-100 border-gray-200" },
];

// Feste Gruppen fuer die Zuweisung
export const TICKET_GROUPS = [
  { id: "Supporter", de: "Supporter", en: "Supporter" },
  { id: "Techniker", de: "Techniker", en: "Technician" },
];

// Ticket-Typ (Phase 2: Ticket = Bestellung)
export const TICKET_TYPES = [
  { id: "versand", de: "Versand / Bestellung", en: "Shipment / order", cls: "text-slate-700 bg-slate-100 border-slate-200" },
  { id: "remote", de: "Remote-Support", en: "Remote support", cls: "text-sky-700 bg-sky-50 border-sky-200" },
  { id: "retoure", de: "Retoure", en: "Return", cls: "text-amber-700 bg-amber-50 border-amber-200" },
  { id: "standort", de: "Neuer Standort", en: "New location", cls: "text-gray-700 bg-gray-100 border-gray-300" },
];
export const typeMeta = (id) => TICKET_TYPES.find((t) => t.id === id) || TICKET_TYPES[0];

export const statusMeta = (id) => TICKET_STATUS.find((s) => s.id === id) || TICKET_STATUS[0];
export const categoryMeta = (id) => TICKET_CATEGORY.find((c) => c.id === id) || TICKET_CATEGORY[4];
export const prioMeta = (id) => TICKET_PRIORITY.find((p) => p.id === id) || TICKET_PRIORITY[1];

export const isOverdue = (t) => {
  if (!t.due_date || t.status === "closed") return false;
  return t.due_date < new Date().toISOString().slice(0, 10);
};

// SLA-Rest-/Ueberschreitungsanzeige (nutzt vom Backend gelieferte Fälligkeiten)
export const slaState = (dueIso, breached, closed) => {
  if (!dueIso) return null;
  if (breached) return { level: "breached" };
  if (closed) return { level: "ok" };
  const ms = new Date(dueIso).getTime() - Date.now();
  const hrs = ms / 3600000;
  if (hrs <= 4) return { level: "soon", hrs };
  return { level: "ok", hrs };
};

export const isOpenLike = (t) => t.status !== "closed";

// Sortierung: offen zuerst, dann ueberfaellig, dann Prioritaet, dann Alter
const PRIO_RANK = { high: 0, normal: 1, low: 2 };
const STATUS_RANK = { open: 0, in_progress: 1, waiting: 2, closed: 3 };
export const sortTickets = (a, b) => {
  const sa = STATUS_RANK[a.status] ?? 0, sb = STATUS_RANK[b.status] ?? 0;
  if (sa !== sb) return sa - sb;
  const oa = isOverdue(a) ? 0 : 1, ob = isOverdue(b) ? 0 : 1;
  if (oa !== ob) return oa - ob;
  const pa = PRIO_RANK[a.priority] ?? 1, pb = PRIO_RANK[b.priority] ?? 1;
  if (pa !== pb) return pa - pb;
  return String(b.created_at).localeCompare(String(a.created_at));
};

export const assigneeLabel = (t, users, de) => {
  if (!t.assignee) return de ? "Nicht zugewiesen" : "Unassigned";
  if (t.assignee_type === "group") return t.assignee;
  const u = (users || []).find((x) => x.email === t.assignee);
  return u ? (u.name || u.email) : t.assignee;
};
